import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { map } from 'lodash'
import { withStyles } from '@material-ui/styles'
import {
  deleteAllDynamicApps,
  deleteDynamicApp,
  getMasterApp,
  resetDagState,
} from 'redux/actions/dagActions'
import { logoutUser } from 'redux/actions/authActions'
import Header from 'components/layout/Partials/Header'
import { Link, NavLink, withRouter } from 'react-router-dom'
import AccessDenied from 'components/common/AccessDenied'
import Loading from 'components/common/Loading'
import * as Icon from 'react-feather'
import moment from 'moment'
import AdminLayout from 'components/layout/AdminLayout'

import { Theme } from 'utils/Theme'
import { setDataTables } from 'redux/actions/dataTablesActions'
import Section from 'components/UI/Section'
const styles = Theme()

class ViewMasterApp extends Component {
  constructor(props) {
    super(props)
    this.state = {
      masterApp: null,
      loading: true,
      errors: {},
      toDelete: null,
    }
    this.updateTablePage = this.updateTablePage.bind(this)
    this.updateTableRows = this.updateTableRows.bind(this)
    this.confirmDelete = this.confirmDelete.bind(this)
    this.deleteAll = this.deleteAll.bind(this)
  }

  componentDidMount() {
    const masterApp = this.props.match.params.id
    this.props.getMasterApp(masterApp)
  }

  componentWillUnmount() {
    this.props.resetDagState()
  }

  updateTablePage = (page, tableName) => {
    const tables = this.props.dataTables
    tables[tableName] = {
      page,
      rows: tables[tableName] ? tables[tableName].totalRows : 20,
    }

    this.props.setDataTables(tables)
  }
  updateTableRows = (page, rows, tableName) => {
    const tables = this.props.dataTables

    tables[tableName] = {
      page,
      rows,
    }
    this.props.setDataTables(tables)
  }
  deleteAll = () => {
    const masterApp = this.props.match.params.id
    this.props.deleteAllDynamicApps(this.props.dag.masterApp['dynamic-apps'])
    this.props.getMasterApp(masterApp)
  }

  confirmDelete = () => {
    this.props.deleteDynamicApp(this.state.toDelete, null)
    this.setState({ toDelete: null })
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    let { masterApp, loading } = prevState

    if (nextProps.dag.masterApp && !nextProps.dag.loading) {
      masterApp = nextProps.dag.masterApp
      loading = nextProps.dag.loading
    }

    return { masterApp, loading }
  }

  render() {
    const { classes, auth, history } = this.props
    const { masterApp, loading } = this.state
    return (
      <AdminLayout>
        <div className="o-page">
          <Header>
            <h2 className="c-navbar__title">Master App</h2>
          </Header>
          {!auth.isAuthenticated || (auth.user.role !== 'Admin' && <AccessDenied props={{ classes, history }} />)}

          {auth.isAuthenticated && auth.user.role === 'Admin' && loading === true && <Loading />}

          {auth.isAuthenticated && auth.user.role === 'Admin' && !loading && masterApp && (
            <div className="u-m-small">
              <Section>
                <div className="u-p-small ">
                  <div className="col-md-12 col-sm-12 col-xl-12 u-mb-medium">
                    <div className="u-m-auto">
                      <div className=" u-p-zero u-m-zero">
                        <div className="o-line c-card__title u-p-small u-m-small">
                          <h4 className={`c-card__title ${classes.colorSecondary}`}>{masterApp.title}</h4>
                          <div className="c-dropdown dropdown">
                            <span
                              className={`c-btn ${classes.buttonPrimary} has-icon dropdown-toggle`}
                              id="MoreActionsDropdown"
                              data-toggle="dropdown"
                              aria-haspopup="true"
                              aria-expanded="false"
                            >
                              More Actions
                            </span>

                            <div
                              className="c-dropdown__menu dropdown-menu has-arrow dropdown-menu-right"
                              aria-labelledby="MoreActionsDropdown"
                            >
                              <div
                                onClick={() => {
                                  history.goBack()
                                }}
                                className="c-dropdown__item dropdown-item"
                              >
                                Back
                              </div>
                              <Link to={`/settings/pages`} className="c-dropdown__item dropdown-item">
                                Pages
                              </Link>
                              <Link to={`/settings/dag/filters`} className="c-dropdown__item dropdown-item">
                                Filters
                              </Link>
                              <Link to={`/settings/dag/master-apps`} className="c-dropdown__item dropdown-item">
                                Master Apps
                              </Link>
                              <Link
                                to={`/settings/dag/master-apps/edit/${masterApp._id}`}
                                className="c-dropdown__item dropdown-item"
                              >
                                Edit Master App
                              </Link>
                              <Link to={`/settings/dag/dynamic-apps`} className="c-dropdown__item dropdown-item">
                                Dynamic Apps
                              </Link>
                            </div>
                          </div>
                        </div>

                        <div className={'row u-p-small'}>
                          <div className="col-md-6 u-m-auto">
                            <div className="c-state-card c-state-card--default">
                              <h4 className="c-state-card__title">Pages</h4>
                              <span className="c-state-card__number">{masterApp?.pages?.length}</span>
                              <p className="c-state-card__status">
                                <i className="feather icon-link"></i> Master Application Pages
                              </p>

                              <div className="c-state-card__actions dropdown">
                                <div
                                  className="dropdown-toggle"
                                  id="dropdownMenuState1"
                                  data-toggle="dropdown"
                                  aria-haspopup="true"
                                  aria-expanded="false"
                                  role="button"
                                >
                                  <i className="feather icon-more-vertical"></i>
                                </div>

                                <div
                                  className="c-dropdown__menu dropdown-menu dropdown-menu-right"
                                  aria-labelledby="dropdownMenuState1"
                                >
                                  <NavLink className="c-dropdown__item dropdown-item" to="/settings/pages">
                                    Pages
                                  </NavLink>
                                  <NavLink className="c-dropdown__item dropdown-item" to="/settings/pages/create">
                                    New Page
                                  </NavLink>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6 u-m-auto">
                            <div className="c-state-card c-state-card--default">
                              <h4 className="c-state-card__title">Dynamic Applications</h4>
                              <span className="c-state-card__number">{masterApp['dynamic-apps']?.length}</span>
                              <p className="c-state-card__status">
                                <i className="feather icon-refresh-ccw"></i> Dynamic Applications
                              </p>

                              <div className="c-state-card__actions dropdown">
                                <div
                                  className="dropdown-toggle"
                                  id="dropdownMenuState1"
                                  data-toggle="dropdown"
                                  aria-haspopup="true"
                                  aria-expanded="false"
                                  role="button"
                                >
                                  <i className="feather icon-more-vertical"></i>
                                </div>

                                <div
                                  className="c-dropdown__menu dropdown-menu dropdown-menu-right"
                                  aria-labelledby="dropdownMenuState1"
                                >
                                  <NavLink className="c-dropdown__item dropdown-item" to="/settings/dag/dynamic-apps">
                                    Dynamic Apps
                                  </NavLink>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="col-md-12">
                            <h5 className={'u-mb-small'}>Pages</h5>
                            <div className="c-table-resposnive">
                              <table className="c-table" style={{ width: '100%' }}>
                                <thead className="c-table__head">
                                  <tr className="c-table__row">
                                    <th className="c-table__cell c-table__cell--head">Title</th>
                                    <th className="c-table__cell c-table__cell--head">Status</th>
                                    <th className="c-table__cell c-table__cell--head">Menu Visible</th>
                                    <th className="c-table__cell c-table__cell--head">Landing Page</th>
                                    <th className="c-table__cell c-table__cell--head">Action</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {masterApp.pages &&
                                    map(masterApp.pages, page => (
                                      <tr className="c-table__row u-text-capitalize" key={page._id}>
                                        <td className="c-table__cell">{page.title}</td>
                                        <td className="c-table__cell">{page.status}</td>
                                        <td className="c-table__cell">{page.menu}</td>

                                        <td className="c-table__cell">
                                          {page.landing ? (
                                            <span
                                              className={`c-badge ${classes.badgeSuccess} clickable  u-m-xsmall c-badge--small has-arrow u-text-center`}
                                            >
                                              <Icon.Check size={10} /> Current
                                            </span>
                                          ) : (
                                            <span
                                              onClick={() => {
                                                // this.setState({makeLanding:
                                                // page._id})
                                                this.updateLandingPage(page._id)
                                              }}
                                              className={`c-badge ${classes.badgePrimary} clickable  u-m-xsmall c-badge--small has-arrow u-text-center`}
                                            >
                                              <Icon.Monitor size={10} /> Set as Landing Page?
                                            </span>
                                          )}
                                        </td>

                                        <td className="c-table__cell" width="120">
                                          <Link
                                            to={`/settings/pages/${page._id}/view`}
                                            className={`c-btn ${classes.buttonPrimary} u-m-xsmall c-btn--small has-arrow u-text-center`}
                                          >
                                            <Icon.BarChart2 size={10} /> Content
                                          </Link>

                                          <Link
                                            to={`/settings/pages/${page._id}/edit`}
                                            className={`c-btn ${classes.buttonInfo} u-m-xsmall c-btn--small has-arrow u-text-center`}
                                          >
                                            <Icon.Edit3 size={10} /> Edit
                                          </Link>
                                          <Link
                                            to={`/settings/pages/${page._id}/delete`}
                                            className={`c-btn ${classes.buttonDanger} u-m-xsmall c-btn--small has-arrow u-text-center`}
                                          >
                                            <Icon.Delete size={10} /> Delete
                                          </Link>
                                        </td>
                                      </tr>
                                    ))}
                                </tbody>
                              </table>
                            </div>
                          </div>

                          <div className="col-md-12">
                            <div className={'o-line'}>
                              <h5 className={'u-mb-small u-mt-small'}>Dynamic Apps</h5>
                              <button
                                onClick={this.deleteAll}
                                className={`c-btn c-btn--small u-m-small ${classes.buttonDanger}`}
                              >
                                Delete All Apps
                              </button>
                            </div>

                            <div className="c-table-resposnive">
                              <table className="c-table">
                                <thead className="c-table__head">
                                  <tr className="c-table__row">
                                    <th className="c-table__cell c-table__cell--head">Dynamic App</th>
                                    <th className="c-table__cell c-table__cell--head">Users</th>
                                    <th className="c-table__cell c-table__cell--head">Created</th>
                                    <th className="c-table__cell c-table__cell--head u-text-right">Actions</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {masterApp['dynamic-apps'] &&
                                    map(masterApp['dynamic-apps'], dynamicApp => (
                                      <tr className="c-table__row" key={dynamicApp._id}>
                                        <td className="c-table__cell">
                                          {' '}
                                          {dynamicApp.title}
                                          <br />
                                          <small
                                            className={'u-text-muted c-tooltip c-tooltip--right'}
                                            aria-label="Qlik Sense App ID"
                                          >
                                            {dynamicApp.qsApp}
                                          </small>
                                        </td>
                                        <td className="c-table__cell">{dynamicApp.users.length}</td>
                                        <td className="c-table__cell">
                                          {moment(dynamicApp.date).format('Do MMM YYYY')}
                                        </td>
                                        <td className="c-table__cell u-text-right">
                                          <button
                                            onClick={() =>
                                              this.props.history.push(
                                                `/settings/dag/dynamic-apps/${dynamicApp._id}/view`
                                              )
                                            }
                                            className={`c-btn ${classes.buttonPrimary} u-m-xsmall c-btn--small has-arrow u-text-center`}
                                          >
                                            <Icon.Eye size={10} /> View
                                          </button>
                                        </td>
                                      </tr>
                                    ))}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Section>
            </div>
          )}
        </div>
      </AdminLayout>
    )
  }
}

ViewMasterApp.propTypes = {
  logoutUser: PropTypes.func.isRequired,
  getMasterApp: PropTypes.func.isRequired,
  deleteAllDynamicApps: PropTypes.func.isRequired,
  deleteDynamicApp: PropTypes.func,
  resetDagState: PropTypes.func,
  auth: PropTypes.object.isRequired,
  dataTables: PropTypes.object,
  setDataTables: PropTypes.func,
  match: PropTypes.object,
  classes: PropTypes.object,
  history: PropTypes.object,
  qlik: PropTypes.object,
  dag: PropTypes.object,
}

const mapStateToProps = state => ({
  auth: state.auth,
  dag: state.dag,
  dataTables: state.dataTables,
})

export default connect(mapStateToProps, {
  logoutUser,
  resetDagState,
  getMasterApp,
  setDataTables,
  deleteDynamicApp,
  deleteAllDynamicApps,
})(withStyles(styles)(withRouter(ViewMasterApp)))
